import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const requireEnv = (value: string | undefined, name: string) => {
   if (!value) {
      throw new Error(`Missing required environment variable: ${name}`);
   }

   return value;
};

const firebaseConfig = {
   apiKey: requireEnv(process.env.REACT_APP_FIREBASE_API_KEY, 'REACT_APP_FIREBASE_API_KEY'),
   authDomain: requireEnv(
      process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      'REACT_APP_FIREBASE_AUTH_DOMAIN',
   ),
   projectId: requireEnv(
      process.env.REACT_APP_FIREBASE_PROJECT_ID,
      'REACT_APP_FIREBASE_PROJECT_ID',
   ),
   storageBucket: requireEnv(
      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      'REACT_APP_FIREBASE_STORAGE_BUCKET',
   ),
   messagingSenderId: requireEnv(
      process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
   ),
   appId: requireEnv(process.env.REACT_APP_FIREBASE_APP_ID, 'REACT_APP_FIREBASE_APP_ID'),
   measurementId: requireEnv(
      process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
      'REACT_APP_FIREBASE_MEASUREMENT_ID',
   ),
};

initializeApp(firebaseConfig);
export const auth = getAuth();
